import { NotificationType } from 'models';
import * as H from 'history';
import { client, consoleLogInDev } from 'shared';

export function handleNotificationAction(
    notification: NotificationType,
    history: H.History,
    setActionMessage: (message: string | undefined) => void,
    openModal: (name: string) => void,
) {
    const webAction = notification.actions?.find((action) => action.action_type === 'web');
    if (webAction?.action === 'navigate') {
        history.push(webAction.path);
    } else if (webAction?.action === 'call_api') {
        const jsonData = webAction.extra_data as Record<string, string | object | undefined> | null;
        client(
            webAction.path,
            jsonData ? { method: jsonData.method as string, body: jsonData.body as object } : undefined,
        )
            .then(() => {
                jsonData?.success_message && setActionMessage(jsonData.success_message as string);
            })
            .catch((error) => {
                consoleLogInDev(error);
                jsonData?.failureMessage && setActionMessage(jsonData.failure_message as string);
            });
    } else if (webAction?.action === 'open_modal') {
        openModal(webAction.path);
    }
}
